/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\ConnexionList\ConnexionList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday December 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday December 11th 2023 3:15:59 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import ConnexionRow from "../ConnexionRow/ConnexionRow";
import { ConnexionRowType } from "Type/Connextion.type";
import translator from "MultiLanguage/TranslationWrapper";
import { memo } from "react";

type ConnexionListProps = {
    data: ConnexionRowType[],
    displayName: boolean
};

const ConnexionListMemo = memo(function ConnexionList (props: ConnexionListProps) {
    const buildTableHeader = () => {
        let tableHeader = ["Status", "Date", "Company", "LastName", "Email", "IP", "Connexion", "Commercial"];
        if (!props.displayName)
            tableHeader = ["Status", "Date", "Company", "IP", "Connexion", "Commercial"];

        return tableHeader.map(val =>
            <TableCell align="center" key={Math.random()}>{translator.decode(`table.headers.${val}`)}</TableCell>
        );
    };

    return (
        <Paper elevation={4}>
            <Table stickyHeader >
                <TableHead>
                    <TableRow>
                        { buildTableHeader() }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((val) => {
                        return <ConnexionRow key={Math.random()} userID={val.Connected.id} FirstName={val.Connected.FirstName} LastName={val.Connected.LastName} Email={val.Connected.Email}
                        Company={val.Connected?.Company?.Name}
                        Commercial={{
                            FirstName: val.Connected.Commercial?.FirstName,
                            LastName: val.Connected.Commercial?.LastName
                        }} Date={val.Date} IP={val.IP} Status={val.Status} From={translator.decode(`connexion.${val.From.toLowerCase()}`)} displayName={props.displayName} />
                    })}
                </TableBody>
            </Table>
        </Paper>
    )
});

export default ConnexionListMemo;
